import React from "react"
import { Modal, Form, Col, Row, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import GetSubscriptionPlans from "../../api/Administration/GetSubscriptionPlans"
import SubscriptionPlan from "../../api/Administration/Model/SubscriptionPlan"
import ActionButton from "../ActionButton"

interface SubscriptionModalProps {
  show: boolean
  subscriptionPlanID: number
  onCancel: () => void
  onSubmit: (subscriptionPlanID: number, subscriptionPlan: SubscriptionPlan) => void
}

interface SubscriptionModalState {
  availableSubscriptionPlans: SubscriptionPlan[]
  loading: boolean
  subscriptionPlanID: number
}

export default class SubscriptionModal extends React.PureComponent<SubscriptionModalProps, SubscriptionModalState> {
  subscription?: Subscription
  state = { loading: false, subscriptionPlanID: this.props.subscriptionPlanID, availableSubscriptionPlans: [] }

  componentDidUpdate(prevProps: SubscriptionModalProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      this.loadSubscriptionPlans()
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  loadSubscriptionPlans = () => {
    this.setState({ loading: true })
    this.subscription = GetSubscriptionPlans().subscribe(
      (data: SubscriptionPlan[]) => this.setState({ loading: false, availableSubscriptionPlans: data }),
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ loading: false })
      },
      () => this.setState({ loading: false })
    )
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onSubmit = () => {
    const selectedPlan: SubscriptionPlan = this.state.availableSubscriptionPlans.filter((plan: SubscriptionPlan) => plan.SubscriptionPlanID === this.state.subscriptionPlanID)[0]
    this.props.onSubmit(this.state.subscriptionPlanID, selectedPlan)
  }

  render() {
    const { availableSubscriptionPlans, loading, subscriptionPlanID,  } = this.state
    const currentPlan: SubscriptionPlan = availableSubscriptionPlans.filter((plan: SubscriptionPlan) => plan.SubscriptionPlanID === this.props.subscriptionPlanID)[0]
    return (
      <>
        <Modal backdrop="static" show={ this.props.show } size="lg" dialogClassName="dark">
          <Modal.Header>
            <Modal.Title className="text-uppercase">Change Subscription</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form className="px-4">
              <Form.Group as={Row}>
                <Form.Label column="sm" sm={3} className="text-lg-right">Current Subscription</Form.Label>
                <Col md={9}>
                  <Form.Control type="text" size="sm" defaultValue={currentPlan?.Title || ""} disabled></Form.Control>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column="sm" sm={3} className="text-lg-right">New Subscription</Form.Label>
                <Col md={9}>
                  <Form.Control as="select" type="text" size="sm" defaultValue={ subscriptionPlanID }
                    disabled={ loading }
                    onChange={ (e: React.ChangeEvent<HTMLInputElement>) => this.setState({ subscriptionPlanID: Number(e.target.value) }) }>
                    <option value="0">Select Subscription</option>
                    {this.state.availableSubscriptionPlans.map((plan: SubscriptionPlan) => <option key={plan.SubscriptionPlanID} value={plan.SubscriptionPlanID} title={plan.Description}>{plan.Title}</option> )}
                  </Form.Control>
                </Col>
              </Form.Group>
              <Form.Row>
                <em className="small">By Clicking the Change Button the Current Subscription will be Deactivated and the New Subscription will become the Active Subscription</em>
              </Form.Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={ this.onCancel } className="px-4">Close</Button>
            <ActionButton variant="primary" onClick={ this.onSubmit } disabled={ loading } disableOnSpin>Update</ActionButton>
          </Modal.Footer>
        </Modal>
      </>
    )
  }

}
